import React from 'react';

interface VerticalDotsButtonProps {
  variant?: 'default' | 'transparent';
}

const VerticalDotsButton: React.FC<VerticalDotsButtonProps> = ({ variant = 'default' }) => {
  // Set background class based on variant
  const bgClass = variant === 'transparent' ? 'bg-transparent' : 'bg-gray-200 bg-white';

  return (
    <div className={`flex justify-center items-center h-9 w-9 rounded-full ${bgClass}`}>
      <div className="flex flex-col justify-between h-5">
        <span className="block w-1 h-1 bg-black rounded-full"></span>
        <span className="block w-1 h-1 bg-black rounded-full"></span>
        <span className="block w-1 h-1 bg-black rounded-full"></span>
      </div>
    </div>
  );
};

export default VerticalDotsButton;
